var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.529,
    r: 5.029,
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.474 16.367c1.854 1.777 2.943 4.144 3.072 6.633H1.454c.13-2.49 1.218-4.856 3.072-6.633 1.98-1.896 4.667-2.965 7.474-2.965 2.807 0 5.495 1.07 7.474 2.965z",
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.de64feb3.svg";
export { ForwardRef as ReactComponent };